import React, { useEffect } from "react";
import {
    FaBolt,
    FaMobileAlt,
    FaRocket,
    FaPaintBrush,
    FaMoneyBillWave,
    FaGlobe
} from "react-icons/fa";
import "./WhyChooseReactNative.css";

const WhyChooseReactNative = () => {

    useEffect(() => {
        const items = document.querySelectorAll(".wrn-card");

        items.forEach((item, i) => {
            item.style.opacity = "0";
            item.style.transform = "translateY(80px)";

            setTimeout(() => {
                item.style.transition = ".8s ease";
                item.style.opacity = "1";
                item.style.transform = "translateY(0)";
            }, i * 150);
        });
    }, []);

    const data = [
        {
            icon: <FaBolt />,
            title: "Fast Development",
            desc: "React Native allows faster development with reusable components and hot reload.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Cross Platform",
            desc: "Build Android & iOS apps together using a single powerful codebase.",
        },
        {
            icon: <FaRocket />,
            title: "Native Performance",
            desc: "Deliver smooth and high-performing applications with native-like experience.",
        },
        {
            icon: <FaPaintBrush />,
            title: "Modern UI/UX",
            desc: "Create visually stunning interfaces with fully customizable UI components.",
        },
        {
            icon: <FaMoneyBillWave />,
            title: "Cost Effective",
            desc: "Reduce development cost and maintenance using one development team.",
        },
        {
            icon: <FaGlobe />,
            title: "Strong Ecosystem",
            desc: "Supported by Meta and backed with a huge developer community worldwide.",
        },
    ];

    return (
        <>
            <section
                style={{
                    position: "relative",
                    padding: "130px 24px",
                    overflow: "hidden",
                    background:
                        "linear-gradient(180deg,#fff 0%,#fff5f5 50%,#fff 100%)",
                }}
            >
                {/* Background Glow */}
                <div className="wrn-blob wrn-blob1"></div>
                <div className="wrn-blob wrn-blob2"></div>

                <div
                    style={{
                        maxWidth: "1250px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    {/* TOP */}
                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "80px",
                        }}
                    >
                        <div className="wrn-mini-badge">
                            ⚛ Why React Native?
                        </div>

                        <h2
                            style={{
                                fontSize: "clamp(40px,5vw,54px)",
                                textAlign: "center",
                                lineHeight: 1,
                                margin: "24px 0 18px",
                                fontFamily: "'Syne',sans-serif",
                                color: "#111",
                            }}
                        >
                            Why Choose{" "}<br />
                            <span
                                style={{
                                    background:
                                        "linear-gradient(135deg,#E8212A,#FF4D4D)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                React Native
                            </span>
                        </h2>

                        <p
                            style={{
                                maxWidth: "760px",
                                margin: "0 auto",
                                textAlign: "center",
                                color: "#666",
                                fontSize: "18px",
                                lineHeight: 1.8,
                                fontFamily:
                                    "'Plus Jakarta Sans',sans-serif",
                            }}
                        >
                            React Native helps businesses build scalable,
                            high-performance and visually engaging mobile
                            applications for both Android & iOS using a
                            single modern framework.
                        </p>
                    </div>

                    {/* MAIN GRID */}
                    <div className="wrn-grid">
                        {data.map((item, i) => (
                            <div
                                key={i}
                                className="wrn-card"
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(-14px)";
                                    e.currentTarget.style.borderColor =
                                        "#E8212A";
                                    e.currentTarget.style.boxShadow =
                                        "0 35px 70px rgba(232,33,42,.15)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(0)";
                                    e.currentTarget.style.borderColor =
                                        "rgba(0,0,0,.05)";
                                    e.currentTarget.style.boxShadow =
                                        "0 15px 35px rgba(0,0,0,.05)";
                                }}
                            >
                                {/* animated glow */}
                                <div className="wrn-glow"></div>

                                <div className="wrn-icon">
                                    {item.icon}
                                </div>

                                <h3>{item.title}</h3>

                                <p>{item.desc}</p>

                                <div className="wrn-line"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyChooseReactNative;